

import axios from 'axios';
import { getCookie } from '../utilities/cookies';


const APP_BACKENDS = {
  hr: 'https://hr.clikkle.com:8000',
  projects: 'https://projects.clikkle.com:8500',
  chat: 'https://chat.clikkle.com:9100',
  campaigns: 'https://campaigns.clikkle.com:9000',
  worksuite: 'https://app.clikkle.com:9160',
};

export const isOrgBasedApp = (type) => {
  const orgBasedApps = ['hr', 'projects', 'project', 'chat', 'campaigns', 'worksuite', 'app'];
  return orgBasedApps.includes(type?.toLowerCase());
};

export const provisionOrganization = async (type, userId, userData) => {
  const appType = type?.toLowerCase();
  const baseUrl = APP_BACKENDS[appType];
  const accessToken = getCookie('accessToken');
  
  if (!baseUrl) {
    throw new Error(`No backend URL defined for app type: ${type}`);
  }

  if (!accessToken || accessToken === "undefined") {
    console.error("No access token available for provisioning");
    throw new Error("Authentication required. Please log in again.");
  }

  const orgName = `${userData.firstName}'s Org`;
  
  let logoBlob = null;
  try {
    const logoResponse = await fetch('/clikkle.png');
    if (logoResponse.ok) {
      logoBlob = await logoResponse.blob();
    }
  } catch (error) {
    console.error("Failed to fetch local logo:", error);
  }

  try {
    let response;
    
    if (appType === 'hr') {
      const formData = new FormData();
      formData.append("name", orgName);
      formData.append("email", userData.email || "");
      formData.append("website", "https://clikkle.com");
      formData.append('portalName', `${orgName.toLowerCase().replace(/[^a-z0-9]/g, '')}.hr.clikkle.com`);
      formData.append('plan', userData.planName);
      formData.append('industry', 'Other');
      formData.append('organizationSize', '0 - 15');
      if (logoBlob) {
        formData.append("photo", logoBlob, "clikkle.png");
      }
      
      response = await axios.post(`${baseUrl}/hr/organization`, formData, {
        headers: { 
          "Authorization": `Bearer ${accessToken}`
        },
      });
    } 
    else if (appType === 'chat') {
      const formData = new FormData();
      formData.append("name", orgName);
      formData.append("email", userData.email || "");
      formData.append("website", "https://clikkle.com");
      formData.append("portalName", `${orgName.toLowerCase().replace(/[^a-z0-9]/g, '')}.chat.clikkle.com`);
      formData.append("plan", userData.planName);
      formData.append("industry", "Other");
      formData.append("organizationSize", "0 - 15");
      if (logoBlob) {
        formData.append("photo", logoBlob, "clikkle.png");
      }

      response = await axios.post(`${baseUrl}/api/organization`, formData, {
        headers: { 
          "Authorization": `Bearer ${accessToken}`
        },
      });
    }
    else if (appType === 'projects' || appType === 'project') {
      const payload = {
        name: orgName,
        email: userData.email || "",
        Email: userData.email || "",
        website: "https://clikkle.com",
        portalName: `${orgName.toLowerCase().replace(/[^a-z0-9]/g, '')}.projects.clikkle.com`,
        plan: userData.planName,
        industry: "Other",
        organizationSize: "0 - 15",
        ownerId: userId,
        userId: userId,
        owner: userId,
        ownerEmail: userData.email || "",
      };

      try {
        response = await axios.post(`${baseUrl}/api/v2/organizations`, payload, {
          headers: { 
            "Content-Type": "application/json",
            "Authorization": `Bearer ${accessToken}`
          },
        });
      } catch (jsonError) {
        console.warn("Projects provisioning via JSON failed, trying FormData...", jsonError.response?.data || jsonError.message);
        
        const formData = new FormData();
        Object.entries(payload).forEach(([key, value]) => formData.append(key, value));
        if (logoBlob) {
          formData.append("image", logoBlob, "clikkle.png");
        }

        response = await axios.post(`${baseUrl}/api/v2/organizations`, formData, {
          headers: { 
            "Authorization": `Bearer ${accessToken}`
          },
        });
      }
    }
    else if (appType === 'campaigns') {
      const formData = new FormData();
      formData.append("name", orgName);
      formData.append("Email", userData.email || "");
      formData.append("Website", "https://clikkle.com");
      formData.append("Address", "Not Provided");
      formData.append("Country", "Not Provided");
      formData.append("ZipCode", "00000");
      formData.append("City", "Not Provided");
      formData.append("CompanyIndustry", "Other");
      formData.append("userId", userId);
      formData.append("ownerId", userId);
      if (logoBlob) {
        formData.append("logo", logoBlob, "clikkle.png");
      }

      response = await axios.post(`${baseUrl}/user/organizations`, formData, {
        headers: { 
          "Authorization": `Bearer ${accessToken}`
        },
      });
    }
    else if (appType === 'worksuite' || appType === 'app') {
      const payload = {
        name: orgName,
        Email: userData.email || "",
        Size: 15,
        Website: "https://clikkle.com",
        Address: "Not Provided",
        Country: "Not Provided",
        ZipCode: "00000",
        City: "Not Provided",
        CompanyIndustry: "Other",
        logo: "", // Worksuite uses JSON, base64 might be needed if logo is required
        userId: userId,
        ownerId: userId,
        owner: userId,
        email: userData.email || "",
        plan: userData.planName,
        portalName: `${orgName.toLowerCase().replace(/[^a-z0-9]/g, '')}.app.clikkle.com`,
        organizationSize: "0 - 15",
        industry: "Other",
        website: "https://clikkle.com",
        status: true,
        folderId: userId,
        type: "Owner",
        totalEmployees: 1
      };

      response = await axios.post(`${baseUrl}/api/organizations`, payload, {
        headers: { 
          "Content-Type": "application/json",
          "Authorization": `Bearer ${accessToken}`
        },
      });
    }

    if (response && response.data) {
      const data = response.data;
      console.log(`Provisioning response for ${appType}:`, data);
    
      
      const orgId = data.orgId || 
                    data._id || 
                    data.organization?._id || 
                    data.data?._id || 
                    (data.success && data.organization?._id) ||
                    data.data?.orgId;

      if (orgId) {
        localStorage.setItem("orgId", orgId);
        return orgId;
      }
    }
    
    if (response?.data?.success) {
      const mockId = `mock_${appType}_${Date.now()}`;
      localStorage.setItem("orgId", mockId);
      return mockId;
    }

    throw new Error("Invalid response from provisioning API");
  } catch (error) {
    console.error(`Provisioning failed for ${appType}:`, error.response?.data || error.message);
    throw error;
  }
};
